'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button } from '~/components/Button';
import { Card } from '~/components/Card/src/Card';
import { Link } from '~/components/Link';
import { useToasts } from '~/components/Toast/src/Toast';
import styles from './ReferralCodeDisplay.module.css';
interface ReferralCodeDisplayProps {
  readonly code: string | null;
}
export function ReferralCodeDisplay(t0) {
  const $ = _c(31);
  const {
    code
  } = t0;
  const t = useTranslations("account");
  const toasts = useToasts();
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== code || $[1] !== t || $[2] !== toasts) {
    t1 = async () => {
      if (!code) {
        return;
      }
      try {
        await navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
        toasts.add({
          title: t("referral_code_copy_toast_title"),
          description: t("referral_code_copy_toast_description"),
          variant: "success",
          position: "middle"
        }, {
          timeout: 3000
        });
      } catch {}
    };
    $[0] = code;
    $[1] = t;
    $[2] = toasts;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleCopyCode = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("referral_code_heading");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <h2 className={styles.heading}>{t2}</h2>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("referral_code_benefit", {
      amount: "\xA350"
    });
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <p className={styles.benefit}>{t4}</p>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("referral_code_body");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `${t6} `;
  let t8;
  if ($[14] !== t) {
    t8 = t("referral_terms_link");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Link hasUnderline={true} href="/legal/referral-programme-terms-and-conditions" isExternal={true}>{t8}</Link>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <p className={styles.body}>{t7}{t9}</p>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== code || $[22] !== copied || $[23] !== handleCopyCode || $[24] !== t) {
    t11 = code ? <div className={styles.codeContainer}><input type="text" value={code} readOnly={true} aria-label={t("referral_code_input_aria")} className={styles.codeInput} data-test-id="referral-code-input" /><Button size="extraSmall" onClick={handleCopyCode} data-test-id="referral-copy-button">{copied ? t("referral_copied") : t("referral_copy_button")}</Button><span className={styles.srOnly} aria-live="polite" aria-atomic="true">{copied ? t("referral_copied") : ""}</span></div> : <p className={styles.loadingText}>{t("referral_code_pending")}</p>;
    $[21] = code;
    $[22] = copied;
    $[23] = handleCopyCode;
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t3 || $[29] !== t5) {
    t12 = <Card colour="greyTertiary" rounded="--by-border-radius-400"><div className={styles.cardWrapper}>{t3}{t5}{t10}{t11}</div></Card>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t3;
    $[29] = t5;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}